import { render, staticRenderFns } from "./ArchivedUserPayrollAdjustments.vue?vue&type=template&id=a01284a4&scoped=true&"
import script from "./ArchivedUserPayrollAdjustments.vue?vue&type=script&lang=ts&"
export * from "./ArchivedUserPayrollAdjustments.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivedUserPayrollAdjustments.vue?vue&type=style&index=0&id=a01284a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01284a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
